export default "__VITE_ASSET__DtlunRsw__"